import React, { FC, ReactNode } from 'react';

import { useIsWebview } from '~/core/hooks/useIsWebview';
import { getEnvironmentAwareHref } from '~/core/utils';

import { SpecialEventInfo } from './styles';

type SpecialEventDetailsProps = {
    eventDetailsContent: ReactNode;
    isEventColumn?: boolean;
    seriesUrl?: string;
};

const SpecialEventDetails: FC<SpecialEventDetailsProps> = ({ eventDetailsContent, isEventColumn, seriesUrl }) => {
    const isWebview = useIsWebview();

    return seriesUrl ? (
        <a href={getEnvironmentAwareHref(seriesUrl, isWebview)}>
            <SpecialEventInfo $isEventColumn={isEventColumn} $isSeriesLink>
                {eventDetailsContent}
            </SpecialEventInfo>
        </a>
    ) : (
        <SpecialEventInfo $isEventColumn={isEventColumn}>{eventDetailsContent}</SpecialEventInfo>
    );
};

export default SpecialEventDetails;
